import React, { ReactElement } from 'react';

import { Layout } from '@components/atoms';
import { Page } from '@constants/enum';
import { useBody } from '@hooks/customHook/useBody';

import B2CAdditionalSurvey from './B2CAdditionalSurveyPage';
import B2CForm from './B2CFormPage';
import B2CMain from './B2CMainPage';
import B2CResult from './B2CResultPage';
import B2CSolution from './B2CSolutionPage';
import CheerUp from './CheerUpPage';
import Completed from './CompletedPage';
import Confirm from './ConfirmPage';
import Continue from './ContinuePage';
import DetailSurvey from './DetailSurveyPage';
import End from './EndPage';
import Expired from './ExpiredPage';
import Footer from './Footer';
import Header from './Header';
import Init from './InitLoadingPage';
import InProgressingPage from './InProgressingPage';
import MainCategory from './MainCategoryPage';
import MainSymptom from './MainSymptomPage';
import ModeSelect from './ModeSelectPage';
import NotFoundError from './NotFoundErrorPage';
import OptionalSurveys from './OptionalSurveysPage';
import PersonalInfoTerm from './PersonalInfoTermPage';
import Review from './ReviewPage';
import ServiceTerm from './ServiceTermPage';
import Term from './TermPage';

function Body(): ReactElement {
  const { pageIndex, setPageIndex, surveyResData, surveyRequestLoading, postSurvey } = useBody();
  return (
    <Layout
      yzTypeLayout={
        [Page.B2CResult, Page.B2CSolution].includes(pageIndex) ? 'B2C_RESULT_BACKGROUND' : 'BODY_BACKGROUND'
      }
    >
      {/* {console.log(Page[pageIndex])} */}
      <Header />
      {pageIndex === Page.B2CMain && <B2CMain setPageIndex={setPageIndex} />}
      {pageIndex === Page.B2CForm && <B2CForm />}
      {pageIndex === Page.B2CResult && <B2CResult setPageIndex={setPageIndex} />}
      {pageIndex === Page.B2CSolution && <B2CSolution setPageIndex={setPageIndex} />}
      {pageIndex === Page.B2CAdditionalSurvey && <B2CAdditionalSurvey />}
      {pageIndex === Page.Continue && <Continue data={surveyResData} />}
      {pageIndex === Page.Init && <Init loading={surveyRequestLoading} />}
      {pageIndex === Page.Term && (
        <Term data={surveyResData} loading={surveyRequestLoading} setPageIndex={setPageIndex} />
      )}
      {pageIndex === Page.MainCategory && <MainCategory />}
      {pageIndex === Page.ModeSelect && <ModeSelect />}
      {pageIndex === Page.MainSymptom && <MainSymptom />}
      {pageIndex === Page.CheerUp && <CheerUp />}
      {pageIndex === Page.DetailSurvey && <DetailSurvey />}
      {pageIndex === Page.OptionalSurveys && <OptionalSurveys />}
      {pageIndex === Page.Confirm && <Confirm />}
      {pageIndex === Page.Review && <Review />}
      {pageIndex === Page.End && <End />}
      {(pageIndex === Page.NotFoundError || !Page[pageIndex]) && <NotFoundError />}
      {pageIndex === Page.Expired && <Expired />}
      {pageIndex === Page.TreatmentIsProgressing && <InProgressingPage />}
      {pageIndex === Page.Completed && <Completed />}
      {pageIndex === Page.ServiceTerm && <ServiceTerm />}
      {pageIndex === Page.PersonalInfoTerm && <PersonalInfoTerm />}
      <Footer data={surveyResData} postSurvey={postSurvey} />
    </Layout>
  );
}

export default Body;
